var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarEmpty(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.623 24.517a1.33 1.33 0 01-.99.479v-.01c-.23.01-.45-.05-.65-.15l-5.98-3.1-5.98 3.12a1.33 1.33 0 01-1.93-1.4l1.1-6.66-4.79-4.75a1.33 1.33 0 01.73-2.27l6.66-1.01 3.02-6.03a1.33 1.33 0 012.38 0l3.02 6.04 6.66 1a1.33 1.33 0 01.74 2.27l-4.8 4.75 1.1 6.66a1.33 1.33 0 01-.29 1.06zm-8.27-4.581c.46-.23 1-.23 1.46 0l5.09 2.64-.93-5.66a1.6 1.6 0 01.45-1.4l4.08-4.04-5.66-.86c-.52-.07-.96-.39-1.19-.85l-2.57-5.12-2.56 5.12c-.24.46-.68.78-1.19.85l-5.66.86 4.07 4.04a1.6 1.6 0 01.45 1.39l-.93 5.67 5.09-2.64z",
    clipRule: "evenodd"
  })));
}

export default SvgStarEmpty;